import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-mobile-field" }
const _hoisted_2 = {
  key: 0,
  class: "field-label"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import { computed, ref, useAttrs, watch } from "vue";
import type { ParsedPhoneNumber } from "awesome-phonenumber";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppMobileField',
  props: /*@__PURE__*/_mergeModels({
    variant: { default: "solo" },
    flat: { type: Boolean, default: true },
    hideDetails: { type: [Boolean, String], default: "auto" },
    label: { default: "" },
    labelIcon: { default: "" },
    defaultCountry: { default: "US" },
    invalidMessage: { default: "Enter a valid phone number" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<string | null>(__props, "modelValue");

const props = __props;

const attrs = useAttrs();
const fieldClass = computed(() => ["app-mobile-field__input", attrs.class]);
const inputValue = ref("");
const phoneInputRef = ref<{
  isValid?: boolean | null;
  errorMessages?: string[] | null;
} | null>(null);
const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs as Record<string, unknown>;
  return rest;
});

watch(
  model,
  (value) => {
    inputValue.value = String(value || "");
  },
  { immediate: true, deep: true },
);

function handleInputValue(value: string | null) {
  inputValue.value = String(value || "");
}

function handlePhoneObject(phoneObject: ParsedPhoneNumber | null) {
  if (!phoneObject) {
    model.value = String(inputValue.value || "").trim();
    return;
  }

  const extension = phoneObject.countryCode ? `+${phoneObject.countryCode}` : "";
  const phone =
    phoneObject.number?.significant?.trim() ||
    phoneObject.number?.input?.replace(/\s+/g, "").trim() ||
    inputValue.value.trim();

  model.value = [extension, phone].filter(Boolean).join(" ").trim();
}

const showInvalidMessage = computed(() => {
  const attrErrorMessages =
    (fieldAttrs.value as Record<string, unknown>)["error-messages"] ??
    (fieldAttrs.value as Record<string, unknown>).errorMessages;

  const hasAttrErrors = Array.isArray(attrErrorMessages)
    ? attrErrorMessages.length > 0
    : Boolean(attrErrorMessages);

  return hasAttrErrors || phoneInputRef.value?.isValid === false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_phone_input = _resolveComponent("v-phone-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (props.labelIcon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "18"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.labelIcon), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(props.label), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_phone_input, _mergeProps({
      ref_key: "phoneInputRef",
      ref: phoneInputRef,
      "model-value": inputValue.value,
      class: fieldClass.value,
      variant: props.variant,
      flat: props.flat,
      "default-country": props.defaultCountry,
      "invalid-message": props.invalidMessage,
      label: "",
      "hide-details": ""
    }, fieldAttrs.value, {
      "onUpdate:modelValue": handleInputValue,
      "onUpdate:phoneObject": handlePhoneObject
    }), null, 16, ["model-value", "class", "variant", "flat", "default-country", "invalid-message"]),
    (showInvalidMessage.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.invalidMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})